/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { TrophyIcon } from '@coursera/cds-icons';

const styles = {
  container: css`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
  `,
  icon: css`
    position: absolute;
  `,
};

const TrophySVG = () => {
  return (
    <div css={styles.container}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_364_24087)" />
        <defs>
          <linearGradient id="paint0_linear_364_24087" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3587FC" />
            <stop offset="1" stopColor="#0056D2" />
          </linearGradient>
        </defs>
      </svg>
      <TrophyIcon size="large" color="invert" css={styles.icon} />
    </div>
  );
};

export default TrophySVG;
